import { render } from "./CartDetail.vue?vue&type=template&id=52f92f1a"
import script from "./CartDetail.vue?vue&type=script&lang=js"
export * from "./CartDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__